import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Strategies from "./pages/Strategies";
import Checkout from "./pages/Checkout";
import ThankYou from "./pages/ThankYou";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Faq from "./pages/Faq";
import StrategyDetails from "./components/StrategyDetails";
import StrategyDetails2 from "./components/StrategyDetails2";
import StrategyDetails3 from "./components/StrategyDetails3";
import StrategyDetails4 from "./components/StrategyDetails4";
import StrategyDetails5 from "./components/StrategyDetails5";
import StrategyDetails6 from "./components/StrategyDetails6";
import StrategyDetails7 from "./components/StrategyDetails7";
import StrategyDetails8 from "./components/StrategyDetails8";
import StrategyDetails9 from "./components/StrategyDetails9";
import StrategyDetails10 from "./components/StrategyDetails10";
import StrategyDetails11 from "./components/StrategyDetails11";
import StrategyDetails12 from "./components/StrategyDetails12";

import ScrollToTop from "./components/ScrollToTop";
import TradingPlatform from "./pages/TradingPlatform";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RiskDisclosure from "./pages/RiskDisclosure";
import ReturnPolicy from "./pages/ReturnPolicy";
import Affiliates from "./pages/Affiliates";
import BlogList from "./components/BlogList";
import BlogPost from "./components/BlogPost";
import ZTAQuantPortfolioDetails from "./components/ZTAQuantPortfolioDetails";
import DelayedPopup from "./components/DelayedPopup";
import PortfolioAnalyzer from "./pages/PortfolioAnalyzer";
import QuantPortfolio from "./pages/QuantPortfolio";
import CustomFormPage from "./pages/FreeAlgoFormPage";
import BookDemo from "./pages/BookDemo";
import DemoBookingThankYou from "./pages/DemoBookingThankYou"; // adjust the import path if necessary

function App() {
  useEffect(() => {
    document.title = "Zion Trading Algos";
  }, []);
  return (
    <Router>
      <DelayedPopup delay={30000} />
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/strategies" element={<Strategies />} />
        <Route path="/strategies/TradeOrFade" element={<StrategyDetails />} />
        <Route path="/strategies/GoldDigger" element={<StrategyDetails3 />} />
        <Route
          path="/strategies/CrudeConqueror"
          element={<StrategyDetails4 />}
        />
        <Route
          path="/strategies/CL Short 30Min"
          element={<StrategyDetails2 />}
        />
        <Route path="/strategies/EquitySurfer" element={<StrategyDetails6 />} />
        <Route path="/strategies/CP NQ 30Min" element={<StrategyDetails5 />} />
        <Route
          path="/strategies/ReversionRally NQ 60Min"
          element={<StrategyDetails7 />}
        />
        <Route path="/strategies/BlueFlame" element={<StrategyDetails9 />} />
        <Route path="/strategies/GC Daily" element={<StrategyDetails8 />} />
        <Route path="/strategies/VS NQ 30Min" element={<StrategyDetails11 />} />
        <Route path="/strategies/WM NQ 10Min" element={<StrategyDetails10 />} />
        <Route
          path="/strategies/ES60 Mean Reversion"
          element={<StrategyDetails12 />}
        />
        <Route path="/platform" element={<TradingPlatform />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/thankyou" element={<ThankYou />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/about" element={<About />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/risk" element={<RiskDisclosure />} />
        <Route path="/return" element={<ReturnPolicy />} />
        <Route path="/affiliates" element={<Affiliates />} />
        <Route path="/blog" element={<BlogList />} />
        <Route path="/blog/post/:id/*" element={<BlogPost />} />
        <Route
          path="/portfolios/zta_quant_portfolio"
          element={<QuantPortfolio />}
        />
        <Route path="/portfolio_analyzer" element={<PortfolioAnalyzer />} />
        <Route path="/free_guide" element={<CustomFormPage />} />
        <Route path="/book-demo" element={<BookDemo />} />
        <Route
          path="/book-demo-confirmed-thankyou"
          element={<DemoBookingThankYou />}
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
